/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PaginationModel model module.
 * @module model/PaginationModel
 * @version v1.0.0
 */
class PaginationModel {
    /**
     * Constructs a new <code>PaginationModel</code>.
     * @alias module:model/PaginationModel
     */
    constructor() { 
        
        PaginationModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PaginationModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PaginationModel} obj Optional instance to populate.
     * @return {module:model/PaginationModel} The populated <code>PaginationModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PaginationModel();

            if (data.hasOwnProperty('defaultPageSize')) {
                obj['defaultPageSize'] = ApiClient.convertToType(data['defaultPageSize'], 'Number');
            }
            if (data.hasOwnProperty('total')) {
                obj['total'] = ApiClient.convertToType(data['total'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * default page size
 * @member {Number} defaultPageSize
 */
PaginationModel.prototype['defaultPageSize'] = undefined;

/**
 * total number of users after filter
 * @member {Number} total
 */
PaginationModel.prototype['total'] = undefined;






export default PaginationModel;

